import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import { setDayjsLocale } from '../utils/day';

export const SUPPORTED_LANGUAGES = [
  { code: 'pt', labelKey: 'language.options.pt', nativeName: 'Portugues' },
  { code: 'en', labelKey: 'language.options.en', nativeName: 'English' },
  { code: 'es', labelKey: 'language.options.es', nativeName: 'Espanol' },
];

export const DEFAULT_LANGUAGE = 'pt';
export const LANGUAGE_STORAGE_KEY = 'app.language';

const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);

const normalizeLanguage = (value) => {
  if (!value) return null;
  const normalized = value.toString().slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGE_CODES.includes(normalized) ? normalized : null;
};

const getStoredLanguage = () => {
  if (typeof window === 'undefined') return null;
  return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
};

const syncDocumentLanguage = (language) => {
  if (typeof document === 'undefined') return;

  document.documentElement.lang = language === 'pt' ? 'pt-BR' : language;
};

const resolveInitialLanguage = () => getStoredLanguage() || DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    pt: { translation: pt },
    es: { translation: es },
  },
  lng: resolveInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES.map((lang) => lang.code),
  nonExplicitSupportedLngs: true,
  load: 'languageOnly',
  interpolation: { escapeValue: false },
  returnNull: false,
});

setDayjsLocale(i18n.resolvedLanguage || i18n.language);
syncDocumentLanguage(
  i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE
);
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(
      LANGUAGE_STORAGE_KEY,
      normalizeLanguage(lng) || DEFAULT_LANGUAGE
    );
  }
  setDayjsLocale(lng);
  syncDocumentLanguage(normalizeLanguage(lng) || DEFAULT_LANGUAGE);
});

export default i18n;
